// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-recharge-page {
  min-height: calc(100vh - 60px);
  padding: 36px 24px 64px;
  color: var(--canvas-ink, #171a17);
  background:
    radial-gradient(circle at 15% 12%, rgba(185, 223, 138, 0.24), transparent 31%),
    radial-gradient(circle at 91% 32%, rgba(255, 255, 255, 0.88), transparent 26%),
    var(--canvas-paper, #f3f5f6);
}

.canvas-recharge-container {
  width: min(1120px, 100%);
  margin: 0 auto;
}

.canvas-recharge-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 28px;
  color: var(--canvas-muted, #737b75);
  font-size: 11px;
}

.canvas-recharge-breadcrumb a {
  color: inherit;
  text-decoration: none;
}

.canvas-recharge-breadcrumb a:hover { color: var(--canvas-ink, #171a17); }
.canvas-recharge-breadcrumb strong { color: var(--canvas-ink, #171a17); font-weight: 650; }

.canvas-recharge-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
  margin-bottom: 34px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--canvas-line, #e2e6e4);
}

.canvas-recharge-heading {
  display: flex;
  max-width: 750px;
  align-items: flex-start;
  gap: 18px;
}

.canvas-recharge-heading-mark {
  display: flex;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-top: 3px;
  background: var(--canvas-ink, #171a17);
  border-radius: 14px;
}

.canvas-recharge-heading-mark i {
  display: block;
  width: 24px;
  height: 7px;
  background: var(--canvas-green, #b9df8a);
  border: 2px solid #171a17;
  border-radius: 50%;
  box-shadow: 0 0 0 1px var(--canvas-green, #b9df8a);
}

.canvas-recharge-eyebrow,
.canvas-recharge-section-heading span,
.canvas-recharge-payment-label > span {
  color: var(--canvas-green-strong, #70a33d);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.canvas-recharge-heading h1 {
  margin: 5px 0 7px;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.08;
}

.canvas-recharge-heading p {
  margin: 0;
  color: var(--canvas-muted, #737b75);
  font-size: 13px;
  line-height: 1.7;
}

.canvas-recharge-balance {
  display: flex;
  min-width: 190px;
  flex-direction: column;
  gap: 6px;
  padding: 15px 18px;
  background: var(--canvas-green-soft, #e3f3cb);
  border: 1px solid var(--canvas-green, #b9df8a);
  border-radius: 12px;
}

.canvas-recharge-balance span { color: #557140; font-size: 10px; }
.canvas-recharge-balance strong {
  overflow: hidden;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 18px;
  font-variant-numeric: tabular-nums;
  text-overflow: ellipsis;
}

.canvas-recharge-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 28px;
  align-items: start;
}

.canvas-recharge-packages {
  min-width: 0;
  padding: 26px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 16px;
  box-shadow: var(--canvas-shadow, 0 10px 32px rgba(24, 30, 26, 0.07));
  backdrop-filter: blur(14px);
}

.canvas-recharge-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
}

.canvas-recharge-section-heading h2 {
  margin: 5px 0 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.canvas-recharge-section-heading small { color: var(--canvas-muted, #737b75); font-size: 10px; }

.canvas-recharge-package-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.canvas-recharge-package {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 148px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  overflow: hidden;
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 13px;
  text-align: left;
  transition: transform 170ms ease, border-color 170ms ease, background 170ms ease, box-shadow 170ms ease;
}

.canvas-recharge-package:hover {
  background: #fff;
  border-color: var(--canvas-line-strong, #ccd2ce);
  box-shadow: 0 10px 24px rgba(24, 30, 26, 0.07);
  transform: translateY(-2px);
}

.canvas-recharge-package.is-selected {
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green-strong, #70a33d);
  box-shadow: inset 0 0 0 1px rgba(112, 163, 61, 0.2);
}

.canvas-recharge-package:focus-visible,
.canvas-recharge-method:focus-visible,
.canvas-recharge-retry:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.canvas-recharge-package-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  max-width: 76px;
  overflow: hidden;
  padding: 4px 7px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 999px;
  font-size: 8px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-recharge-package-points {
  max-width: 100%;
  overflow: hidden;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: clamp(20px, 2vw, 27px);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-recharge-package-unit {
  margin: 2px 0 13px;
  color: var(--canvas-muted, #737b75);
  font-size: 9px;
}

.canvas-recharge-package-price {
  color: #59615a;
  font-size: 12px;
  font-weight: 700;
}

.canvas-recharge-package-check {
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #fff;
  background: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
  font-size: 11px;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 150ms ease, transform 150ms ease;
}

.canvas-recharge-package.is-selected .canvas-recharge-package-check { opacity: 1; transform: scale(1); }

.canvas-recharge-note {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin-top: 22px;
  padding: 16px 17px;
  color: var(--canvas-muted, #737b75);
  background: #f3f5f4;
  border-radius: 11px;
  font-size: 10px;
  line-height: 1.6;
}

.canvas-recharge-note strong { flex-basis: 100%; color: var(--canvas-ink, #171a17); font-size: 11px; }
.canvas-recharge-note span::before { content: '·'; margin-right: 6px; color: var(--canvas-green-strong, #70a33d); }

.canvas-recharge-payment {
  position: sticky;
  top: 84px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 26px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 16px;
  box-shadow: 0 18px 48px rgba(24, 30, 26, 0.1);
  backdrop-filter: blur(16px);
}

.canvas-recharge-payment-label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 18px;
}

.canvas-recharge-payment-label strong { font-size: 16px; }

.canvas-recharge-methods { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; margin-bottom: 20px; }

.canvas-recharge-method {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px;
  color: #626963;
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 9px;
  font-size: 11px;
  font-weight: 650;
}

.canvas-recharge-method:hover { background: #fff; border-color: var(--canvas-line-strong, #ccd2ce); }
.canvas-recharge-method.is-selected { color: var(--canvas-ink, #171a17); background: var(--canvas-green-soft, #e3f3cb); border-color: var(--canvas-green-strong, #70a33d); }

.canvas-recharge-method-mark {
  display: grid;
  width: 21px;
  height: 21px;
  place-items: center;
  color: #fff;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 800;
}

.canvas-recharge-method-mark.is-wechat { background: #1aad19; }
.canvas-recharge-method-mark.is-alipay { background: #1677ff; }

.canvas-recharge-qr-shell {
  display: grid;
  width: 218px;
  height: 218px;
  place-self: center;
  place-items: center;
  padding: 12px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(24, 30, 26, 0.08);
}

.canvas-recharge-qr-shell img { display: block; width: 100%; height: 100%; object-fit: contain; }

.canvas-recharge-qr-placeholder,
.canvas-recharge-payment-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--canvas-muted, #737b75);
}

.canvas-recharge-qr-symbol { color: #adb5af; font-size: 48px; line-height: 1; }

.canvas-recharge-spinner {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 2px solid var(--canvas-line, #e2e6e4);
  border-top-color: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
  animation: canvas-recharge-spin 750ms linear infinite;
}

@keyframes canvas-recharge-spin { to { transform: rotate(360deg); } }

.canvas-recharge-payment-success > span {
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  color: #fff;
  background: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
  font-size: 27px;
}

.canvas-recharge-payment-success strong { color: var(--canvas-ink, #171a17); font-size: 17px; }
.canvas-recharge-payment-success small { font-size: 10px; }

.canvas-recharge-payment-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin-top: 20px;
  color: var(--canvas-ink, #171a17);
}

.canvas-recharge-payment-price del { margin-right: 7px; color: #9aa29c; font-size: 11px; }
.canvas-recharge-payment-price > span { font-size: 16px; font-weight: 750; }
.canvas-recharge-payment-price strong { font-family: 'SFMono-Regular', Consolas, monospace; font-size: 34px; letter-spacing: -0.055em; }

.canvas-recharge-discount,
.canvas-recharge-waiting {
  margin: 7px 0 0;
  color: var(--canvas-green-strong, #70a33d);
  font-size: 9px;
  text-align: center;
}

.canvas-recharge-waiting { color: var(--canvas-muted, #737b75); }
.canvas-recharge-waiting i { display: inline-block; width: 6px; height: 6px; margin-right: 4px; background: var(--canvas-green-strong, #70a33d); border-radius: 50%; }

.canvas-recharge-retry {
  min-height: 38px;
  margin-top: 14px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 9px;
  font-size: 11px;
  font-weight: 700;
}

.canvas-recharge-retry:hover { color: var(--canvas-ink, #171a17); background: var(--canvas-green-soft, #e3f3cb); border-color: var(--canvas-green, #b9df8a); }

.canvas-recharge-order-number {
  max-width: 100%;
  margin-top: 15px;
  overflow: hidden;
  color: #9aa29c;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas-recharge-back {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 15px;
  color: #59615a;
  border-top: 1px solid var(--canvas-line, #e2e6e4);
  font-size: 10px;
  font-weight: 650;
  text-decoration: none;
}

.canvas-recharge-back:hover { color: var(--canvas-green-strong, #70a33d); }

.canvas-recharge-loading,
.canvas-recharge-error {
  display: flex;
  min-height: 300px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--canvas-muted, #737b75);
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 16px;
  font-size: 12px;
}

.canvas-recharge-error strong { color: var(--canvas-ink, #171a17); font-size: 16px; }
.canvas-recharge-error button { padding: 8px 15px; color: #fff; background: var(--canvas-ink, #171a17); border: 0; font-size: 11px; }

@media (max-width: 920px) {
  .canvas-recharge-layout { grid-template-columns: 1fr; }
  .canvas-recharge-payment { position: static; }
  .canvas-recharge-package-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}

@media (max-width: 680px) {
  .canvas-recharge-page { padding: 24px 16px 44px; }
  .canvas-recharge-header { align-items: stretch; flex-direction: column; }
  .canvas-recharge-heading-mark { width: 46px; height: 46px; flex-basis: 46px; }
  .canvas-recharge-balance { min-width: 0; }
  .canvas-recharge-packages,
  .canvas-recharge-payment { padding: 18px; }
  .canvas-recharge-package-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .canvas-recharge-package { min-height: 136px; padding: 16px; }
  .canvas-recharge-section-heading { align-items: flex-start; flex-direction: column; gap: 6px; }
}

@media (max-width: 420px) {
  .canvas-recharge-heading { gap: 12px; }
  .canvas-recharge-heading h1 { font-size: 27px; }
  .canvas-recharge-heading p { font-size: 12px; }
  .canvas-recharge-package-grid { grid-template-columns: 1fr; }
  .canvas-recharge-package { min-height: 124px; }
  .canvas-recharge-qr-shell { width: min(218px, 100%); aspect-ratio: 1; height: auto; }
}

@media (prefers-reduced-motion: reduce) {
  .canvas-recharge-package,
  .canvas-recharge-package-check { transition: none; }
  .canvas-recharge-spinner { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/recharge/PointsRechargePage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;EACjC;;;gCAG8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,sCAAsC,iCAAiC,EAAE;AACzE,qCAAqC,iCAAiC,EAAE,gBAAgB,EAAE;;AAE1F;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;;;EAGE,0CAA0C;EAC1C,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;EAC7C,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,gCAAgC,cAAc,EAAE,eAAe,EAAE;AACjE;EACE,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;EACf,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,mBAAmB;EACnB,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,yCAAyC,mCAAmC,EAAE,eAAe,EAAE;;AAE/F;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,+CAA+C;EAC/C,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,uGAAuG;AACzG;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;;;EAGE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kDAAkD;EAClD,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA,sEAAsE,UAAU,EAAE,mBAAmB,EAAE;;AAEvG;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B,gBAAgB,EAAE,iCAAiC,EAAE,eAAe,EAAE;AACrG,qCAAqC,YAAY,EAAE,iBAAiB,EAAE,0CAA0C,EAAE;;AAElH;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,wCAAwC,eAAe,EAAE;;AAEzD,2BAA2B,aAAa,EAAE,8BAA8B,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAEzG;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,+CAA+C;EAC/C,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC,gBAAgB,EAAE,gDAAgD,EAAE;AACpG,sCAAsC,iCAAiC,EAAE,6CAA6C,EAAE,iDAAiD,EAAE;;AAE3K;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;;AAE9D;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,gCAAgC,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEhG;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mCAAmC;AACrC;;AAEA,6BAA6B,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE9E;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,qDAAqD;EACrD,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,kCAAkC,KAAK,yBAAyB,EAAE,EAAE;;AAEpE;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0CAA0C,iCAAiC,EAAE,eAAe,EAAE;AAC9F,yCAAyC,eAAe,EAAE;;AAE1D;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,qCAAqC,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AACzF,wCAAwC,eAAe,EAAE,gBAAgB,EAAE;AAC3E,wCAAwC,kDAAkD,EAAE,eAAe,EAAE,wBAAwB,EAAE;;AAEvI;;EAEE,eAAe;EACf,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B,mCAAmC,EAAE;AAChE,6BAA6B,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE,+CAA+C,EAAE,kBAAkB,EAAE;;AAErK;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B,iCAAiC,EAAE,6CAA6C,EAAE,0CAA0C,EAAE;;AAE7J;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8BAA8B,0CAA0C,EAAE;;AAE1E;;EAEE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,qCAAqC;EACrC,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gCAAgC,iCAAiC,EAAE,eAAe,EAAE;AACpF,gCAAgC,iBAAiB,EAAE,WAAW,EAAE,sCAAsC,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEpI;EACE,0BAA0B,0BAA0B,EAAE;EACtD,2BAA2B,gBAAgB,EAAE;EAC7C,gCAAgC,gDAAgD,EAAE;AACpF;;AAEA;EACE,wBAAwB,uBAAuB,EAAE;EACjD,0BAA0B,oBAAoB,EAAE,sBAAsB,EAAE;EACxE,gCAAgC,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE;EAC7E,2BAA2B,YAAY,EAAE;EACzC;6BAC2B,aAAa,EAAE;EAC1C,gCAAgC,gDAAgD,EAAE;EAClF,2BAA2B,iBAAiB,EAAE,aAAa,EAAE;EAC7D,mCAAmC,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChG;;AAEA;EACE,2BAA2B,SAAS,EAAE;EACtC,8BAA8B,eAAe,EAAE;EAC/C,6BAA6B,eAAe,EAAE;EAC9C,gCAAgC,0BAA0B,EAAE;EAC5D,2BAA2B,iBAAiB,EAAE;EAC9C,4BAA4B,uBAAuB,EAAE,eAAe,EAAE,YAAY,EAAE;AACtF;;AAEA;EACE;mCACiC,gBAAgB,EAAE;EACnD,2BAA2B,eAAe,EAAE;AAC9C","sourcesContent":[".canvas-recharge-page {\n  min-height: calc(100vh - 60px);\n  padding: 36px 24px 64px;\n  color: var(--canvas-ink, #171a17);\n  background:\n    radial-gradient(circle at 15% 12%, rgba(185, 223, 138, 0.24), transparent 31%),\n    radial-gradient(circle at 91% 32%, rgba(255, 255, 255, 0.88), transparent 26%),\n    var(--canvas-paper, #f3f5f6);\n}\n\n.canvas-recharge-container {\n  width: min(1120px, 100%);\n  margin: 0 auto;\n}\n\n.canvas-recharge-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 28px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 11px;\n}\n\n.canvas-recharge-breadcrumb a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.canvas-recharge-breadcrumb a:hover { color: var(--canvas-ink, #171a17); }\n.canvas-recharge-breadcrumb strong { color: var(--canvas-ink, #171a17); font-weight: 650; }\n\n.canvas-recharge-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 32px;\n  margin-bottom: 34px;\n  padding-bottom: 28px;\n  border-bottom: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.canvas-recharge-heading {\n  display: flex;\n  max-width: 750px;\n  align-items: flex-start;\n  gap: 18px;\n}\n\n.canvas-recharge-heading-mark {\n  display: flex;\n  width: 54px;\n  height: 54px;\n  flex: 0 0 54px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-top: 3px;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 14px;\n}\n\n.canvas-recharge-heading-mark i {\n  display: block;\n  width: 24px;\n  height: 7px;\n  background: var(--canvas-green, #b9df8a);\n  border: 2px solid #171a17;\n  border-radius: 50%;\n  box-shadow: 0 0 0 1px var(--canvas-green, #b9df8a);\n}\n\n.canvas-recharge-eyebrow,\n.canvas-recharge-section-heading span,\n.canvas-recharge-payment-label > span {\n  color: var(--canvas-green-strong, #70a33d);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n}\n\n.canvas-recharge-heading h1 {\n  margin: 5px 0 7px;\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 700;\n  letter-spacing: -0.045em;\n  line-height: 1.08;\n}\n\n.canvas-recharge-heading p {\n  margin: 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 13px;\n  line-height: 1.7;\n}\n\n.canvas-recharge-balance {\n  display: flex;\n  min-width: 190px;\n  flex-direction: column;\n  gap: 6px;\n  padding: 15px 18px;\n  background: var(--canvas-green-soft, #e3f3cb);\n  border: 1px solid var(--canvas-green, #b9df8a);\n  border-radius: 12px;\n}\n\n.canvas-recharge-balance span { color: #557140; font-size: 10px; }\n.canvas-recharge-balance strong {\n  overflow: hidden;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 18px;\n  font-variant-numeric: tabular-nums;\n  text-overflow: ellipsis;\n}\n\n.canvas-recharge-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 28px;\n  align-items: start;\n}\n\n.canvas-recharge-packages {\n  min-width: 0;\n  padding: 26px;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 16px;\n  box-shadow: var(--canvas-shadow, 0 10px 32px rgba(24, 30, 26, 0.07));\n  backdrop-filter: blur(14px);\n}\n\n.canvas-recharge-section-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 22px;\n}\n\n.canvas-recharge-section-heading h2 {\n  margin: 5px 0 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n\n.canvas-recharge-section-heading small { color: var(--canvas-muted, #737b75); font-size: 10px; }\n\n.canvas-recharge-package-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.canvas-recharge-package {\n  position: relative;\n  display: flex;\n  min-width: 0;\n  min-height: 148px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 20px;\n  overflow: hidden;\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 13px;\n  text-align: left;\n  transition: transform 170ms ease, border-color 170ms ease, background 170ms ease, box-shadow 170ms ease;\n}\n\n.canvas-recharge-package:hover {\n  background: #fff;\n  border-color: var(--canvas-line-strong, #ccd2ce);\n  box-shadow: 0 10px 24px rgba(24, 30, 26, 0.07);\n  transform: translateY(-2px);\n}\n\n.canvas-recharge-package.is-selected {\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green-strong, #70a33d);\n  box-shadow: inset 0 0 0 1px rgba(112, 163, 61, 0.2);\n}\n\n.canvas-recharge-package:focus-visible,\n.canvas-recharge-method:focus-visible,\n.canvas-recharge-retry:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.canvas-recharge-package-tag {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  max-width: 76px;\n  overflow: hidden;\n  padding: 4px 7px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 999px;\n  font-size: 8px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-recharge-package-points {\n  max-width: 100%;\n  overflow: hidden;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: clamp(20px, 2vw, 27px);\n  font-weight: 750;\n  letter-spacing: -0.045em;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-recharge-package-unit {\n  margin: 2px 0 13px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 9px;\n}\n\n.canvas-recharge-package-price {\n  color: #59615a;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.canvas-recharge-package-check {\n  position: absolute;\n  right: 12px;\n  bottom: 12px;\n  display: grid;\n  width: 22px;\n  height: 22px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n  font-size: 11px;\n  opacity: 0;\n  transform: scale(0.7);\n  transition: opacity 150ms ease, transform 150ms ease;\n}\n\n.canvas-recharge-package.is-selected .canvas-recharge-package-check { opacity: 1; transform: scale(1); }\n\n.canvas-recharge-note {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 18px;\n  margin-top: 22px;\n  padding: 16px 17px;\n  color: var(--canvas-muted, #737b75);\n  background: #f3f5f4;\n  border-radius: 11px;\n  font-size: 10px;\n  line-height: 1.6;\n}\n\n.canvas-recharge-note strong { flex-basis: 100%; color: var(--canvas-ink, #171a17); font-size: 11px; }\n.canvas-recharge-note span::before { content: '·'; margin-right: 6px; color: var(--canvas-green-strong, #70a33d); }\n\n.canvas-recharge-payment {\n  position: sticky;\n  top: 84px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 26px;\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 16px;\n  box-shadow: 0 18px 48px rgba(24, 30, 26, 0.1);\n  backdrop-filter: blur(16px);\n}\n\n.canvas-recharge-payment-label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 18px;\n}\n\n.canvas-recharge-payment-label strong { font-size: 16px; }\n\n.canvas-recharge-methods { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; margin-bottom: 20px; }\n\n.canvas-recharge-method {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 8px;\n  color: #626963;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 650;\n}\n\n.canvas-recharge-method:hover { background: #fff; border-color: var(--canvas-line-strong, #ccd2ce); }\n.canvas-recharge-method.is-selected { color: var(--canvas-ink, #171a17); background: var(--canvas-green-soft, #e3f3cb); border-color: var(--canvas-green-strong, #70a33d); }\n\n.canvas-recharge-method-mark {\n  display: grid;\n  width: 21px;\n  height: 21px;\n  place-items: center;\n  color: #fff;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.canvas-recharge-method-mark.is-wechat { background: #1aad19; }\n.canvas-recharge-method-mark.is-alipay { background: #1677ff; }\n\n.canvas-recharge-qr-shell {\n  display: grid;\n  width: 218px;\n  height: 218px;\n  place-self: center;\n  place-items: center;\n  padding: 12px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(24, 30, 26, 0.08);\n}\n\n.canvas-recharge-qr-shell img { display: block; width: 100%; height: 100%; object-fit: contain; }\n\n.canvas-recharge-qr-placeholder,\n.canvas-recharge-payment-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: var(--canvas-muted, #737b75);\n}\n\n.canvas-recharge-qr-symbol { color: #adb5af; font-size: 48px; line-height: 1; }\n\n.canvas-recharge-spinner {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--canvas-line, #e2e6e4);\n  border-top-color: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n  animation: canvas-recharge-spin 750ms linear infinite;\n}\n\n@keyframes canvas-recharge-spin { to { transform: rotate(360deg); } }\n\n.canvas-recharge-payment-success > span {\n  display: grid;\n  width: 58px;\n  height: 58px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n  font-size: 27px;\n}\n\n.canvas-recharge-payment-success strong { color: var(--canvas-ink, #171a17); font-size: 17px; }\n.canvas-recharge-payment-success small { font-size: 10px; }\n\n.canvas-recharge-payment-price {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 2px;\n  margin-top: 20px;\n  color: var(--canvas-ink, #171a17);\n}\n\n.canvas-recharge-payment-price del { margin-right: 7px; color: #9aa29c; font-size: 11px; }\n.canvas-recharge-payment-price > span { font-size: 16px; font-weight: 750; }\n.canvas-recharge-payment-price strong { font-family: 'SFMono-Regular', Consolas, monospace; font-size: 34px; letter-spacing: -0.055em; }\n\n.canvas-recharge-discount,\n.canvas-recharge-waiting {\n  margin: 7px 0 0;\n  color: var(--canvas-green-strong, #70a33d);\n  font-size: 9px;\n  text-align: center;\n}\n\n.canvas-recharge-waiting { color: var(--canvas-muted, #737b75); }\n.canvas-recharge-waiting i { display: inline-block; width: 6px; height: 6px; margin-right: 4px; background: var(--canvas-green-strong, #70a33d); border-radius: 50%; }\n\n.canvas-recharge-retry {\n  min-height: 38px;\n  margin-top: 14px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.canvas-recharge-retry:hover { color: var(--canvas-ink, #171a17); background: var(--canvas-green-soft, #e3f3cb); border-color: var(--canvas-green, #b9df8a); }\n\n.canvas-recharge-order-number {\n  max-width: 100%;\n  margin-top: 15px;\n  overflow: hidden;\n  color: #9aa29c;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.canvas-recharge-back {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 18px;\n  padding-top: 15px;\n  color: #59615a;\n  border-top: 1px solid var(--canvas-line, #e2e6e4);\n  font-size: 10px;\n  font-weight: 650;\n  text-decoration: none;\n}\n\n.canvas-recharge-back:hover { color: var(--canvas-green-strong, #70a33d); }\n\n.canvas-recharge-loading,\n.canvas-recharge-error {\n  display: flex;\n  min-height: 300px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--canvas-muted, #737b75);\n  background: rgba(255, 255, 255, 0.84);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 16px;\n  font-size: 12px;\n}\n\n.canvas-recharge-error strong { color: var(--canvas-ink, #171a17); font-size: 16px; }\n.canvas-recharge-error button { padding: 8px 15px; color: #fff; background: var(--canvas-ink, #171a17); border: 0; font-size: 11px; }\n\n@media (max-width: 920px) {\n  .canvas-recharge-layout { grid-template-columns: 1fr; }\n  .canvas-recharge-payment { position: static; }\n  .canvas-recharge-package-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n}\n\n@media (max-width: 680px) {\n  .canvas-recharge-page { padding: 24px 16px 44px; }\n  .canvas-recharge-header { align-items: stretch; flex-direction: column; }\n  .canvas-recharge-heading-mark { width: 46px; height: 46px; flex-basis: 46px; }\n  .canvas-recharge-balance { min-width: 0; }\n  .canvas-recharge-packages,\n  .canvas-recharge-payment { padding: 18px; }\n  .canvas-recharge-package-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .canvas-recharge-package { min-height: 136px; padding: 16px; }\n  .canvas-recharge-section-heading { align-items: flex-start; flex-direction: column; gap: 6px; }\n}\n\n@media (max-width: 420px) {\n  .canvas-recharge-heading { gap: 12px; }\n  .canvas-recharge-heading h1 { font-size: 27px; }\n  .canvas-recharge-heading p { font-size: 12px; }\n  .canvas-recharge-package-grid { grid-template-columns: 1fr; }\n  .canvas-recharge-package { min-height: 124px; }\n  .canvas-recharge-qr-shell { width: min(218px, 100%); aspect-ratio: 1; height: auto; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .canvas-recharge-package,\n  .canvas-recharge-package-check { transition: none; }\n  .canvas-recharge-spinner { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
